import axios from 'axios';

import { parseLiaForFE, parseSoftDeleteLiaForBE, parseUpdateLiaForBE } from './lia.parsers';
import type { LiaApi, LiaDTO, SoftDeleteLiaInput } from './lia.types';

const buildLiaEndpoint = (organizationId: number, purposeId: number) =>
  `api/v1/organizations/${organizationId}/processing-purposes/${purposeId}/lia/`;

const buildSoftDeleteEndpoint = (organizationId: number, purposeId: number) => `${buildLiaEndpoint(organizationId, purposeId)}soft-delete/`;

export const liaApi: LiaApi = {
  get: async (organizationId, purposeId) => {
    const { data } = await axios.get<LiaDTO>(buildLiaEndpoint(organizationId, purposeId));
    return { data: parseLiaForFE(data) };
  },
  // The endpoint is idempotent: an existing LIA is returned with 200, a newly created one with 201.
  getOrCreate: async (organizationId, purposeId) => {
    const { data } = await axios.post<LiaDTO>(buildLiaEndpoint(organizationId, purposeId));
    return { data: parseLiaForFE(data) };
  },
  update: async (organizationId, purposeId, payload) => {
    const { data } = await axios.patch<LiaDTO>(buildLiaEndpoint(organizationId, purposeId), parseUpdateLiaForBE(payload));
    return { data: parseLiaForFE(data) };
  },
  softDelete: async (organizationId, purposeId, payload: SoftDeleteLiaInput) => {
    const { data } = await axios.post<LiaDTO>(buildSoftDeleteEndpoint(organizationId, purposeId), parseSoftDeleteLiaForBE(payload));
    return { data: parseLiaForFE(data) };
  },
};

export default liaApi;
